import React, { useState } from "react";
import { FloatingLabel, Form } from "react-bootstrap";
import "./inputField.scss";

interface InputFormProps {
  inputId: string;
  inputLable?: string;
  inputClassName?: string;
  inputType: string;
  inputPlaceholder?: string;
  inputChecked?: boolean;
  register?: any;
  required?: any;
  error?: any;
  onBlur?: any;
  onFocus?: any;
  defaultValue?: string;
  disabled?: boolean;
  onChange?: any;
}

const InputForm: React.FC<InputFormProps> = ({
  onChange,
  inputId,
  inputLable,
  inputClassName = "",
  inputType,
  inputPlaceholder,
  inputChecked = false,
  register,
  error,
  onBlur,
  onFocus,
  defaultValue,
  required,
  disabled,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword((prevState) => !prevState);
  };

  return (
    <Form.Group controlId={inputId} className={`mb-3 ${inputClassName}`}>
      <FloatingLabel
        controlId={inputId}
        label={
          required ? (
            <>
              {inputLable}
              <span className="text-danger">*</span>
            </>
          ) : (
            inputLable
          )
        }
      >
        <Form.Control
          type={showPassword && inputType === "password" ? "text" : inputType}
          placeholder={inputPlaceholder}
          {...register}
          isInvalid={!!error}
          onBlur={onBlur}
          onFocus={onFocus}
          defaultValue={defaultValue}
          disabled={disabled}
          // onChange={onChange && onChange}
        />
        {inputType === "password" && (
          <span
            className="password-toggle-icon"
            onClick={togglePasswordVisibility}
          >
            <i
              className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}
            ></i>
          </span>
        )}
        {inputChecked && (
          <span className="input-checked">
            <i className="fa-solid fa-check"></i>
          </span>
        )}
        {error && (
          <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
        )}
      </FloatingLabel>
    </Form.Group>
  );
};

export default InputForm;
